import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import NewHeader from './components/NewHeader';
import NewHero from './components/NewHero';
import Features from './components/Features';
import CarouselHowYouStart from './components/CarouselHowYouStart';
import WhoIsThisFor from './components/WhoIsThisFor';
import WhyInviteOnly from './components/WhyInviteOnly';
import PricingTable from './components/PricingTable';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import './index.css';

function App() {
  // Add a smooth scroll effect for anchor links
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const href = e.currentTarget.getAttribute('href');
      if (href && href.startsWith('#') && href.length > 1) {
        e.preventDefault();
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 80,
            behavior: 'smooth'
          });
        }
      }
    };

    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach(anchor => {
      anchor.addEventListener('click', handleAnchorClick);
    });

    return () => {
      anchorLinks.forEach(anchor => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []);

  return (
    <motion.div 
      className="min-h-screen bg-white"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <NewHeader />
      <NewHero />
      <Features />
      <CarouselHowYouStart />
      <WhoIsThisFor />
      <WhyInviteOnly />
      <PricingTable />
      <FAQ />
      <Footer />
    </motion.div>
  );
}

export default App;